module.exports = __webpack_public_path__ + "img/emotion-customization@2x.482892d.webp";